import React, { useEffect, useState } from 'react';
import Collapse, { Panel } from 'rc-collapse';
import Big from 'big.js';
import moment from 'moment';

import { messages } from '../../../../helpers/messages';
import LoaderGroups from './Loader/LoaderGroups';
import { methods } from '../helper';
import { cashBoxService } from '../../../../services/cashbox-service';
import { transactionsService } from '../../../../services/transactions-service';
import { Transactions } from '.';

const TransactionGroups = ({
                               cashBoxIds,
                               startDate,
                               endDate,
                               rerender,
                               onRevertParent,
                               cash,
                               cashBox,
                               successRolesAllCash,
                               availableDepartments,
                               branchDirector
                           }) => {
  const [state, setState] = useState({
    groups: [],
    reasons: {},
    loading: false,
  });

  const [totalSum, setTotalSum] = useState({ totalCredit: 0, totalDebit: 0 });
  
  useEffect(() => {
    getTransactionGroups();
  }, [startDate, endDate, cashBoxIds, rerender, cash]);

  const onRevert = () => {
    getTransactionGroups();
    onRevertParent();
  };

  const getTransactionGroups = () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    let data = {
      cashBoxIds: cashBoxIds,
      startDate: startDate ? startDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      endDate: endDate ? endDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      cash
    };
      if (successRolesAllCash && cashBox.length === 0) {
          delete data.cashBoxIds
      }
      if (branchDirector && cashBoxIds.length === 0) {
          data.cashBoxIds = availableDepartments
      }
    Promise.all([cashBoxService.getReasons(''), transactionsService.getTransactionGroups(data)])
      .then(([reasonsResponse, response]) => {
        let reasonsArray = reasonsResponse.data.reasons;
        let reasons = {};
        reasonsArray.forEach((value) => {
          reasons[value.code + ''] = value;
        });

        const { groups } = response.data;

        setState((prev) => ({
          ...prev,
          reasons: reasons,
          groups,
          loading: false,
        }));

        const totalCredit = groups
          .filter(({ type }) => type === 'CREDIT')
          .filter(({ section }) => section !== 'REPAYMENT_CREDIT')
          .map(({ sum }) => sum)
          .reduce((p, c) => {
            let t = new Big(c);
            t = t.plus(p);
            return t;
          }, 0)
          .toFixed(2);

        const totalDebit = groups
          .filter(({ type }) => type === 'DEBIT')
          .filter(({ section }) => section !== 'REPAYMENT_DEBIT')
          .map(({ sum }) => sum)
          .reduce((p, c) => new Big(c).plus(p), 0)
          .toFixed(2);

        setTotalSum({ totalCredit, totalDebit });
      })
      .catch((err) => {
        if (err.response) {
          let errorData = err.response.data;
          let commonError = messages['0'];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          setState((prev) => ({
            ...prev,
            loading: false,
            error: commonError,
          }));
        }
      });
  };

  return state.loading ? (
    <LoaderGroups pageRange={10} />
  ) : (
    <table className="table hover">
      <thead>
        <tr>
          <th scope="col">Тип транзакции</th>
          <th scope="col">Приход, BYN</th>
          <th scope="col" colSpan="2">
            Расход, BYN
          </th>
        </tr>
      </thead>
      <tbody>
        {state.groups &&
          state.groups.map((group, index) => {
            return (
              <React.Fragment key={group.section + index}>
                <tr>
                  <th scope="row">
                    <span className="caption">Тип транзакции</span>
                    <div className="table-cellcontent">
                      {/* <Checkbox label={''} id={'checkboxClient1'} name={'checkboxClient1Name'} /> */}
                      <p>{methods.convertGroupType(group.section, state.reasons)}</p>
                    </div>
                  </th>
                  <td>
                    {group.type === 'CREDIT' && (
                      <>
                        <span className="caption">Приход, BYN</span>
                        <p>{group.sum.toFixed(2)}</p>
                      </>
                    )}
                  </td>
                  <td>
                    {group.type === 'DEBIT' && (
                      <>
                        <span className="caption">Расход, BYN</span>
                        <p>{group.sum.toFixed(2)}</p>
                      </>
                    )}
                  </td>
                </tr>
                <tr className="table-rowcollapse">
                  <td colSpan="4">
                    {/*TODO all open blocks causes requests when change date*/}
                    <Collapse className="rc-collapse-rowitem">
                      <Panel
                        header=""
                        key={group.section}
                        headerClass="block-datacollapse-header-row"
                        className="block-datacollapse-container-row">
                        <Transactions
                          startDate={startDate}
                          cashBoxIds={cashBoxIds}
                          endDate={endDate}
                          section={group.section}
                          type={group.type}
                          onRevert={onRevert}
                          cash={cash}
                          cashBox={cashBox}
                          successRolesAllCash={successRolesAllCash}
                        />
                      </Panel>
                    </Collapse>
                  </td>
                </tr>
                  <tr></tr>
              </React.Fragment>
            );
          })}
      </tbody>
      <tfoot>
        <tr>
          <td>Итого:</td>
          <td>{totalSum.totalCredit}</td>
          <td>{totalSum.totalDebit}</td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TransactionGroups;
